import { createAction } from "@reduxjs/toolkit";

export const showLoading = createAction('@Api/SHOW_LOADING');
export const hideLoading = createAction('@Api/HIDE_LOADING');

export type LoadingActionTypes = typeof showLoading | typeof hideLoading;
